import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  AddBusinessPlace,
  DeleteBusiness,
  DeleteBusinessUpdates,
  GetBuinessImages,
  GetBuinessPlaceApi,
  GetBuinessPlaceByNameApi,
  GetBuinessPlaceBySearchpi,
  GetBusinessUpdateList,
} from 'redux/services/BuinessPlaceService';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import axios from 'components/Axios';

export const BusinessPlaceSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addBusinessMessage: {},
    getLists: [],
    getProfile: '',
    getImages: '',
  },
  reducers: {
    addBusinessMessage: (state, action) => {
      state.addBusinessMessage = action.payload;
    },
    buinessPlaceList: (state, action) => {
      state.getLists = action.payload;
    },
    getProfile: (state, action) => {
      state.getProfile = [action.payload];
    },
    getImages: (state, action) => {
      state.getImages = action.payload;
    },
  },
});

export const addBuinessPlace = (payload, url, method) => async () => {
  if (method === 'delete') {
    const promise = axios.delete(`${url}`, {
      data: payload,
    });
    const dataPromise = promise.then((response) => response);
    return dataPromise;
  } else {
    return AddBusinessPlace(payload, url, method);
  }
};

export const getBuinessPlaceList = (url) => async (dispatch) => {
  dispatch(SetLoading());
  try {
    GetBuinessPlaceApi(url).then((response) => {
      dispatch(buinessPlaceList(response.data.data || response?.data));
    });
  } catch (err) {
    Notification('warning', err.response?.data?.message);
  } finally {
    setTimeout(() => {
      dispatch(ClearLoading());
    }, 1000);
  }
};

export const getBuinessPlaceListByUsername = (url) => async (dispatch) => {
  dispatch(SetLoading());
  try {
    GetBuinessPlaceByNameApi(url).then((response) => {
      dispatch(buinessPlaceList(response.data.data || response?.data));
    });
  } catch (err) {
    Notification('warning', err.response?.data?.message);
  } finally {
    setTimeout(() => {
      dispatch(ClearLoading());
    }, 1000);
  }
};

export const getBuinessPlaceListBySearch = (url) => async (dispatch) => {
  dispatch(SetLoading());
  try {
    GetBuinessPlaceBySearchpi(url).then((response) => {
      dispatch(buinessPlaceList(response.data.data || response?.data));
    });
  } catch (err) {
    Notification('warning', err.response?.data?.message);
  } finally {
    setTimeout(() => {
      dispatch(ClearLoading());
    }, 1000);
  }
};

export const getBusinessImagesList = (id) => async (dispatch) => {
  GetBuinessImages(id).then((response) => {
    dispatch(getImages(response.data));
  });
};

export const resetBusinessImage = () => (dispatch) => {
  dispatch(getImages(''));
};

export const getBusinessListUpdate = (id) => async () => {
  return GetBusinessUpdateList(id);
};

export const DeleteBuinessUpdatesByuserId = (id, attachment) => async () => {
  return DeleteBusinessUpdates(id, attachment);
};

export const DeleteBuinessByuserId = (id) => async () => {
  return DeleteBusiness(id);
};

export const resetBuinessPlaceList = () => async (dispatch) => {
  dispatch(buinessPlaceList([]));
};

export const { buinessPlaceList, addBusinessMessage, getImages, resetList } =
  BusinessPlaceSlice.actions;
export default BusinessPlaceSlice.reducer;
